import React from 'react';

import { Media } from 'react-bootstrap';

interface IMediaListGroupContentProps {
    className?: string;
}

export const MediaListGroupContent = ({children, className}: React.PropsWithChildren<IMediaListGroupContentProps>) => {
    return (
        <Media.Body className={`align-self-center ${className || ''}`}>
            {children}
        </Media.Body>
    );
};